import { render } from "./BulkMint.vue?vue&type=template&id=8ad653fc&scoped=true"
import script from "./BulkMint.vue?vue&type=script&lang=js"
export * from "./BulkMint.vue?vue&type=script&lang=js"

import "./BulkMint.vue?vue&type=style&index=0&id=8ad653fc&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ad653fc"]])

export default __exports__